<div #container
     class="container bg2 page-sub footer-none">

  <section #header
           class="header fixed">

    <article class="header-page">

      <a class="close-btn" backButton></a>

      <div class="page-name-box">오픈 소스 라이선스 고지</div>

    </article>

  </section>

  <section class="setting-page">
    <div class="inner wrap">

      <div class="setting-list">

        <div class="setting-box">
          <div class="setting-des-box">
            듣고 배우는 한국어 버전: {{ versionTxt }}
          </div>
        </div>

        <!-- div class="setting-box">
          <div class="setting-tit-box">Angular</div>
          <div class="setting-des-box">
            The MIT License<br/>
            <br/>
            Copyright (c) 2010-2021 Google LLC. <a href="http://angular.io/license">http://angular.io/license</a>
          </div>
        </div -->

        <!-- spinner -->
        <div class="setting-box" *ngIf="listLicense.length === 0">
          <div class="reload-icon">
            <img src="assets/img/loading_icon.gif">
          </div>
        </div>

        <!-- 스크립트로 자동으로 추가한 라이선스 -->
        <div class="setting-box"
             *ngFor="let license of listLicense">
          <div class="setting-tit-box">{{ license.name }}</div>
          <div class="setting-des-box license">
            <ng-container *ngIf="license.version">
              <div class="sub-txt">버전:</div>
              <div class="con-txt">{{ license.version }}</div>
            </ng-container>

            <ng-container *ngIf="license.licenses">
              <div class="sub-txt">라이선스:</div>
              <div class="con-txt">
                <span [class.link]="license.licenseFile || license.licenseUrl"
                      (click)="license.licenseFile ? onClickLicense($event, license) : (
                        license.licenseUrl ? onClickUrl($event, license.licenseUrl) : null)">
                  {{ license.licenses }}
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="license.publisher">
              <div class="sub-txt">발행자:</div>
              <div class="con-txt">{{ license.publisher }}</div>
            </ng-container>

            <ng-container *ngIf="license.email">
              <div class="sub-txt">이메일 주소:</div>
              <div class="con-txt"><a href="mailto:{{ license.email }}">{{ license.email }}</a></div>
            </ng-container>

            <ng-container *ngIf="license.url">
              <div class="sub-txt">홈페이지:</div>
              <div class="con-txt">
                <a (click)="onClickUrl($event, license.url)">{{ license.url }}</a>
              </div>
            </ng-container>

            <ng-container *ngIf="license.repository">
              <div class="sub-txt">저장소:</div>
              <div class="con-txt">
                <a (click)="onClickUrl($event, license.repository)">{{ license.repository }}</a>
              </div>
            </ng-container>

          </div>
          <app-license-view *ngIf="currentLicense === license && license.licenseFile"
                            @expandCollapse
                            (close)="onCloseLicense()"
                            [license]="license"></app-license-view>
        </div>

      </div>

    </div>

  </section>

</div>
